import { createSlice } from "@reduxjs/toolkit";

const emptyResourceHolder = {
  meta: {
    count: 0,
    lastFetched: null,
  },
  list: [],
};

export const initialState = {
  codecs: { ...emptyResourceHolder },
  dispatchers: { ...emptyResourceHolder },
  lineKeyTypes: { ...emptyResourceHolder },
};

const systemSlice = createSlice({
  name: "system",
  initialState,
  reducers: {
    setCodecStore(state, action) {
      state.codecs = {
        list: action.payload.codecs,
        meta: { count: action.payload.count, lastFetched: new Date().toString() },
      };
    },
    setDispatcherStore: (state, action) => {
      state.dispatchers = {
        list: action.payload.dispatchers,
        meta: { count: action.payload.count, lastFetched: new Date().toString() },
      };
    },
    setLineKeyTypeStore(state, action) {
      state.lineKeyTypes = {
        list: action.payload.lineKeyTypes,
        meta: { count: action.payload.count, lastFetched: new Date().toString() },
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase("root/clearAuthData", () => {
      return initialState;
    });
  },
});

export const { setCodecStore, setDispatcherStore, setLineKeyTypeStore } = systemSlice.actions;

export default systemSlice.reducer;
